export const OrderBatchErrorsActionTypes = {
    API_RESPONSE_SUCCESS: '@@order-batch-errors/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@order-batch-errors/API_RESPONSE_ERROR',
    GET_ALL_ORDER_BATCH_ERRORS: '@@order-batch-errors/GET_ALL_ORDER_BATCH_ERRORS',
    RESET_STATE: '@@order-batch-errors/RESET_STATE',
    RESET_ALL_ERRORS: '@@order-batch-errors/RESET_ALL_ERRORS',
};
